import React from 'react';
import { Button } from '@mui/material';
import { CSSTransition } from 'react-transition-group';
import './NotificationController.scss';
import { useNotificationManager } from '../../hooks/useNotificationManager';

const NotificationController: React.FC = () => {
  const { activeCount, destroyAll } = useNotificationManager();

  const showButton = activeCount >= 2;

  return (
    <CSSTransition in={showButton} timeout={300} classNames="dismiss-button" unmountOnExit>
      <div className="dismiss-button-container">
        <Button
          variant="contained"
          size="small"
          onClick={destroyAll}
          sx={{
            borderRadius: '4px',
            boxShadow: 3,
            textTransform: 'none',
          }}
        >
          Скрыть все ({activeCount})
        </Button>
      </div>
    </CSSTransition>
  );
};

export default NotificationController;
